import * as React from "react";

import { NewCommentWrapper, AddCommentLabel } from "./new-comment-box-style";
import UserCircleImage from "../../../views/user-circle-image/user-circle-image";
import OverlayEditor from "../../../deprecated/OverlayEditor";
import HasOverlayComponent, {
    HasOverlayState,
    HasOverlayProps,
} from "../../has-overlay-component/has-overlay-component";
import { getLocalizedString } from "common/components/localization";
import { AppCredentials } from "../../../../chrome/smart/app-container/app-container-types";
import { AuthScreenMode } from "../../../../chrome/smart/app-modal-provider/app-modal-provider-types";
import { AppEnvironment } from "common/components/types";
import { requestPushNotificationPermissionIfNecessary } from "../../../../lib/push-notifications";
import { withCredentials } from "../../../../lib/with-credentials";
import { withModals, ModalController } from "../../../../chrome/smart/app-modal-provider/app-modal-provider";

interface BaseProps extends HasOverlayProps {
    readonly postComment: (username: string, email: string | undefined, comment: string) => void;
    readonly onTapNew?: () => void;
    readonly appEnvironment: AppEnvironment;
}

interface Props extends BaseProps {
    readonly credentials: AppCredentials;
    readonly modals: ModalController;
}

interface State extends HasOverlayState {
    comment: string | undefined;
}

class NewCommentBoxInner extends HasOverlayComponent<Props, State> {
    public state: State = {
        comment: "",
    };

    private onClick = async (_ev: React.MouseEvent<HTMLButtonElement>): Promise<void> => {
        const creds = this.props.credentials;
        const { username, email } = creds;
        const loggedIn = creds.isAuthenticated && email.length > 0 && username.length > 0;

        if (!loggedIn) {
            const result = await this.props.modals.openAuthModal(
                getLocalizedString("comment"),
                AuthScreenMode.Username
            );
            if (!result) return;
        }
        if (this.props.onTapNew !== undefined) {
            this.props.onTapNew();
        } else {
            this.showOverlay();
        }
        await requestPushNotificationPermissionIfNecessary();
    };

    private onUserImageClick = async (ev: React.MouseEvent<HTMLDivElement>): Promise<void> => {
        ev.stopPropagation();
        await this.props.modals.openAuthModal(getLocalizedString("comment"), AuthScreenMode.Username, true);
    };

    private onSaved = (text: string): void => {
        this.onClosed();
        const { username, email } = this.props.credentials;
        if (username.length > 0) {
            this.props.postComment(username, email, text);
        }
    };

    private onClosed = () => {
        this.hideOverlay();
    };

    public render(): React.ReactNode {
        const creds = this.props.credentials;
        const { username, email } = creds;
        const { renderEnvironment } = this.props;

        let portal: React.ReactPortal | undefined;
        if (this.shouldRenderPortal()) {
            const content = (
                <OverlayEditor
                    renderEnvironment={renderEnvironment}
                    title={getLocalizedString("comment")}
                    placeholder={getLocalizedString("writeAComment")}
                    saved={this.onSaved}
                    saveIcon={"send"}
                    saveText={getLocalizedString("post")}
                    closed={this.onClosed}
                    allowEmpty={false}
                />
            );
            portal = this.getPortal(content);
        }

        return (
            <>
                <NewCommentWrapper onClick={this.onClick} aria-label={getLocalizedString("addComment")}>
                    <UserCircleImage onClick={this.onUserImageClick} size={38} username={username} email={email} />
                    <AddCommentLabel>{getLocalizedString("addComment")}</AddCommentLabel>
                </NewCommentWrapper>
                {portal}
            </>
        );
    }
}

const NewCommentBox = withModals(withCredentials(NewCommentBoxInner));
export default NewCommentBox;
